import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Title from "../../../components/Title";
import {
  CreateTwoTone,
  DeleteOutlineRounded,
} from "@material-ui/icons";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LeaveService from "../../../services/LeaveService";
import { escapeRegExp } from "../../../utils";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@material-ui/data-grid";
import CheckIcon from "@material-ui/icons/Send";
import CloseIcon from "@material-ui/icons/Close";
import RemoveIcon from "@material-ui/icons/Remove";
import FileService from "../../../services/FileService";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import {
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  CircularProgress,
  Popover,
} from "@material-ui/core";

import ConfirmationDialog from "../../tools/ConfirmationDialog";
import Message from "../../tools/Message";
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";
import Alert from "@material-ui/lab/Alert";
import MotifAnnulationLeave from "../../tools/MotifAnnulationLeave";
import UserService from "../../../services/UserService";

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  btnAnnulerDialog: {
    background: "red",
    color: "white",
  },
  btnValiderDialog: {
    background: "rgb(19, 62, 103)",
    color: "white",
  },
  label: {
    fontWeight: "bold",
  },
  id: {
    color: "#3f51b5",
    fontWeight: "bold",
  },
  balanceSummary: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.75),
    fontSize: "14px",
  },
  balanceLine: {
    color: "#5f6368",
    fontWeight: 500,
  },
  currentBalanceLine: {
    whiteSpace: "nowrap",
  },
  currentBalance: {
    color: "rgb(19, 62, 103)",
    fontWeight: 700,
    backgroundColor: "#e8f1f8",
    borderRadius: "12px",
    padding: theme.spacing(0.25, 1),
  },
  confirmedBalance: {
    color: "#2e7d32",
    fontWeight: 700,
    backgroundColor: "#e8f5e9",
    borderRadius: "12px",
    padding: theme.spacing(0.25, 1),
  },
  balanceUnavailable: {
    color: "#757575",
    fontStyle: "italic",
  },
  balanceSummaryContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    boxSizing: "border-box",
    gap: theme.spacing(2),
    padding: theme.spacing(1.25, 1.5),
    backgroundColor: "#fafcfe",
    border: "1px solid #d9e4ec",
    borderRadius: "8px",
    boxShadow: "0 2px 6px rgba(19, 62, 103, 0.08)",
  },
  balanceDetailsButton: {
    flexShrink: 0,
    borderColor: "rgb(19, 62, 103)",
    color: "rgb(19, 62, 103)",
    fontWeight: 700,
    textTransform: "none",
    backgroundColor: "#ffffff",
    "&:hover": {
      borderColor: "rgb(19, 62, 103)",
      backgroundColor: "#e8f1f8",
    },
  },
  balanceDetailsPaper: {
    borderRadius: "10px",
    border: "1px solid #d9e4ec",
    boxShadow: "0 8px 24px rgba(19, 62, 103, 0.2)",
  },
  balanceDetails: {
    width: "360px",
    maxWidth: "calc(100vw - 32px)",
    padding: theme.spacing(2.25),
  },
  balanceDetailsTitle: {
    marginBottom: theme.spacing(1.5),
    paddingBottom: theme.spacing(1),
    borderBottom: "2px solid #e8f1f8",
    color: "rgb(19, 62, 103)",
    fontSize: "17px",
    fontWeight: 700,
  },
  balanceDetailsRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    padding: theme.spacing(1, 0),
    borderBottom: "1px solid #eeeeee",
    color: "#5f6368",
  },
  balanceDetailsValue: {
    whiteSpace: "nowrap",
    color: "rgb(19, 62, 103)",
    fontWeight: 700,
  },
  balanceDetailsActions: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(2),
  },
  balanceDetailsCloseButton: {
    color: "#ffffff",
    backgroundColor: "rgb(19, 62, 103)",
    fontWeight: 700,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "rgb(15, 50, 83)",
    },
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  searchInput: {
    flex: 1,
  },
  applyButton: {
    height: "40px",
    minWidth: "120px",
    backgroundColor: "rgb(19, 62, 103)",
    color: "white",
    "&:hover": {
      backgroundColor: "rgb(15, 50, 83)",
    },
  },
  resetButton: {
    height: "40px",
    minWidth: "100px",
    backgroundColor: "#f50057",
    color: "white",
    "&:hover": {
      backgroundColor: "#c40045",
    },
  },
  filterContainer: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: "#f9f9f9",
    borderRadius: "4px",
  }
}));

export default function LeaveTable(props) {
  const [id_to_delete, setId_to_delete] = useState(0);
  const [confirmationDialog, setConfirmationDialog] = React.useState({
    openDialog: false,
    messageDialog: 'voulez vous supprimer?',
  });
  const { openDialog, messageDialog } = confirmationDialog;
  const [message, setMessage] = React.useState({
    openMessage: false,
    color: 'green',
    messageInfo: '',
  });
  const { openMessage, color, messageInfo } = message;
  const [iscancel, setIscancel] = React.useState(false);
  const [data, setData] = React.useState(false);
  const classes = useStyles();
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [filename, setFilename] = React.useState("");

  const [lastname, setlastname] = React.useState("");
  const [duration, setduration] = React.useState("");
  const [reason, setreason] = React.useState("");
  const [type, settype] = React.useState("");
  const [beginMoment, setBeginMoment] = React.useState("");
  const [beginMomentSession, setBeginMomentSession] = React.useState("");
  const [beginTime, setBeginTime] = React.useState("");
  const [leavecode, setLeavecode] = React.useState("");
  const [leaveid, setIdleave] = useState();
  const [leave, setLeave] = useState();

  const [endMoment, setEndMoment] = React.useState("");
  const [endMomentSession, setEndMomentSession] = React.useState("");
  const [endTime, setEndTime] = React.useState("");
  const [nomprenom, setNomprenom] = React.useState("");

  const [firstname, setFirstname] = React.useState("");
  const [leaveID, setLeaveID] = React.useState(0);
  const [filePath, setfilePath] = React.useState("");
  const [qrCode, setQrCode] = React.useState("");
  const [solde_Previsionnelle, setSolde_Previsionnelle] = React.useState("");
  const [solde_relle, setSolde_relle] = React.useState("");
  const [nomprenomSup, setNomprenomSup] = React.useState("");
  const [superStatus, setSuperStatus] = React.useState("");
  const [userSupList, setuserSupList] = React.useState([]);

  const [balanceBefore, setBalanceBefore] = useState(0);
  const [balanceAfters, setBalanceAfters] = useState(0);
  const [realdelta, setRealdelta] = useState(0);
  const [afterdelta, setAfterdelta] = useState(0);
  const [statuus, setStatuus] = useState(0);
  const [idobselete, setIdobselete] = useState('');
  const [codeobselete, setCodeobselete] = useState('');
  const [raison, setRaison] = useState('');

  const [isLoading, setLoading] = useState(false);
  const [isLoadingSendForValidation, setLoadingSendForValidation] = useState(false);
  const [isLoadingHandleValidateLeave, setLoadingHandleValidateLeave] = useState(false);
  const [cancel, setCancel] = React.useState(false);
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);

  const [isRealBalanceAlreadyConfigurate, setIsRealBalanceAlreadyConfigurate] = useState(false);
  const [errorMessageForRealBalanceEmpty, setErrorMessageForRealBalanceEmpty] = useState("");
  const [userConnectedName, setUserConnectedName] = useState('');
  const [userConnectedActualBalance, setUserConnectedActualBalance] = useState('');
  const [pendingConfirmationDuration, setPendingConfirmationDuration] = useState(0);
  const [pendingValidationDuration, setPendingValidationDuration] = useState(0);
  const [isPendingBalanceAvailable, setIsPendingBalanceAvailable] = useState(false);
  const [balanceDetailsAnchorEl, setBalanceDetailsAnchorEl] = useState(null);
  const [idLeaveToCancel, setIdLeaveToCancel] = React.useState(0);
  const [emptyMotif, setEmptyMotif] = React.useState(false);

  const [isPlanning, setIsPlanning] = React.useState(false);
  const [isValidPlanning, setIsValidPlanning] = React.useState(false);
  const [isValidatorNumberConfigurate, setIsValidatorNumberConfigurate] = useState(false);
  const [dayOffNumberWithoutValidation, setDayOffNumberWithoutValidation] = useState(false);

  // État unique pour le statut sélectionné
  const [selectedStatus, setSelectedStatus] = useState(1);
  
  const [searchTerm, setSearchTerm] = useState("");
  
  const navigate = useNavigate();

  const loadPendingRealLeaveDurations = useCallback(async () => {
    setIsPendingBalanceAvailable(false);

    try {
      const [confirmationResult, validationResult] = await Promise.all([
        LeaveService.getPendingRealPaidLeaveDuration(),
        LeaveService.getPendingRealPaidLeaveValidationDuration(),
      ]);

      if (confirmationResult?.status && validationResult?.status) {
        setPendingConfirmationDuration(Number(confirmationResult.data) || 0);
        setPendingValidationDuration(Number(validationResult.data) || 0);
        setIsPendingBalanceAvailable(true);
      }
    } catch (error) {
      setIsPendingBalanceAvailable(false);
    }
  }, []);

  // Fonction pour appliquer le filtre
  const applyFilter = useCallback(() => {
    if (!searchTerm || searchTerm.trim() === "") {
      setFilteredRows(rows);
      return;
    }
    
    const searchRegex = new RegExp(escapeRegExp(searchTerm), "i");
    const filtered = rows.filter((row) => {
      return Object.keys(row).some((field) => {
        if (row[field] === null || row[field] === undefined) return false;
        return searchRegex.test(row[field].toString());
      });
    });
    setFilteredRows(filtered);
  }, [searchTerm, rows]);

  // Fonction pour réinitialiser le filtre
  const resetFilter = useCallback(() => {
    setSearchTerm("");
    setFilteredRows(rows);
  }, [rows]);

  // Fonction pour charger les données
  const LoadTable = useCallback(() => {
    setOpenLoadingSimpleBackdrop(true);
    const currentStatus = selectedStatus; 
    
    LeaveService.getLeavesByOptions().then((result) => {
      if (result) {
        
        let newRows = [];

        if (currentStatus === 2) {
          // Statut Planning
          newRows = result.planning?.map((row) => ({ ...row, id: row.leave_id, file: row.file_request_id })) || [];
        } else if (currentStatus === 1) {
          // Statut Réel
          newRows = result.reel?.map((row) => ({ ...row, id: row.leave_id, file: row.file_request_id })) || [];
        } else if (currentStatus === 0) {
          // Statut Nouveau
          newRows = result.nouveau?.map((row) => ({ ...row, id: row.leave_id, file: row.file_request_id })) || [];
        }
        
        setRows(newRows);
        setFilteredRows(newRows);
      }
      setOpenLoadingSimpleBackdrop(false);
    }).catch(() => {
      setOpenLoadingSimpleBackdrop(false);
    });
  }, [selectedStatus]);

  // Initialisation des données
  useEffect(() => {
    const initialStatus = props.status || parseInt(localStorage.getItem("status")) || 1;
    setSelectedStatus(initialStatus);
  }, [props.status]);

  // Charger les types de congés - une seule fois
  useEffect(() => {
    LeaveService.getLeaveType().then((result) => {
      if (result && result.data) {
        setLeaveTypes(
          result.data.map((d) => {
            return { id: d.leave_type_id, label: d.name, desc: d.desc };
          })
        );
      }
    });

    UserService.checkValidatornumberByUserId(0).then((results) => {
      if (results && results.status) {
        setIsValidatorNumberConfigurate(true);
        setDayOffNumberWithoutValidation(results.data.user_validator_number_dayNumberWithoutValidation);
      }
    });
  }, []);

  // Charger les données quand le statut change
  useEffect(() => {
    LoadTable();
  }, [selectedStatus, LoadTable]);

  useEffect(() => {
    loadPendingRealLeaveDurations();
  }, [loadPendingRealLeaveDurations]);

  // Mettre à jour les données utilisateur depuis les props
  useEffect(() => {
    if (props.userConnectedName) {
      setUserConnectedName(props.userConnectedName);
    }
    if (props.userConnectedActualBalance !== null && props.userConnectedActualBalance !== undefined) {
      setUserConnectedActualBalance(props.userConnectedActualBalance);
    }
  }, [props.userConnectedName, props.userConnectedActualBalance]);

  const currentBalance = Number(userConnectedActualBalance) || 0;
  const pendingConfirmation = Number(pendingConfirmationDuration) || 0;
  const pendingValidation = Number(pendingValidationDuration) || 0;
  const totalPendingDuration = pendingConfirmation + pendingValidation;
  const balanceAfterValidationAndConfirmation = currentBalance - totalPendingDuration;
  const isBalanceDetailsOpen = Boolean(balanceDetailsAnchorEl);

  const handleOpenBalanceDetails = (event) => {
    setBalanceDetailsAnchorEl(event.currentTarget);
  };

  const handleCloseBalanceDetails = () => {
    setBalanceDetailsAnchorEl(null);
  };

  // Gestion du changement de statut
  const handleChangeStatus = useCallback((event) => {
    const newStatus = event.target.value;
    setSelectedStatus(newStatus);
    localStorage.setItem("status", newStatus);
  }, []);

  const getFullName = useCallback((params) => {
    return `${params.getValue(params.id, 'last_name') || ''} ${params.getValue(params.id, 'first_name') || ''}`;
  }, []);

  const handleDelete = useCallback((id) => (ev) => {
    setIscancel(false);
    setId_to_delete(id);
    setConfirmationDialog({ ...confirmationDialog, openDialog: true, messageDialog: 'voulez vous supprimer?' });
  }, [confirmationDialog]);

  const closeDialog = useCallback(() => {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false, messageDialog: 'voulez vous supprimer?' });
  }, [confirmationDialog]);

  const confirmDialog = useCallback(() => {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false, messageDialog: 'voulez vous supprimer?' });
    LeaveService.deleteLeave(id_to_delete).then((result) => {
      LeaveService.getLeaveType().then((results) => {
        if (results && results.data) {
          setData(results.data);
          LoadTable();
        }
      });
      if (result.status) {
        loadPendingRealLeaveDurations();
        setMessage({ ...message, openMessage: true, color: 'green', messageInfo: result.message });
      } else {
        setMessage({ ...message, openMessage: true, color: 'red', messageInfo: result.message });
      }
    }).catch((err) => {
      setMessage({ ...message, openMessage: true, color: 'red', messageInfo: 'erreur' });
    });
  }, [confirmationDialog, id_to_delete, message, LoadTable, loadPendingRealLeaveDurations]);

  const cancelDialog = useCallback(() => {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }, [confirmationDialog]);

  const handleCloseMessage = useCallback(() => {
    setMessage({ ...message, openMessage: false });
  }, [message]);

  const handleEdit = useCallback((id) => (ev) => {
    navigate(`/me/leaves/add/${id}`);
  }, [navigate]);

  const handleValide = useCallback((id) => (ev) => {
    navigate(`/me/leaves/add/valide/${id}`);
  }, [navigate]);

  const handleGenerateFile = useCallback((id) => (ev) => {
    setOpenLoadingSimpleBackdrop(true);
    setLoadingSendForValidation(true);
    
    FileService.generateFile(id)
      .then((res) => {
        if (res.status) {
          setOpen(true);
          setOpenLoadingSimpleBackdrop(false);
          setfilePath(res.filepath);
          setFilename(res.filename);
          setFirstname(res.firstname);
          setlastname(res.lastname);
          setduration(res.duration);
          setreason(res.reason);
          settype(res.type);
          setSolde_Previsionnelle(res.solde_Previsionnelle);
          setSolde_relle(res.solde_relle);
          setBeginMoment(res.beginMoment);
          setSuperStatus(res.superStatus);
          setEndMoment(res.endMoment);
          setBeginMomentSession(res.beginTimeSession);
          setEndMomentSession(res.endTimeSession);
          setLeavecode(res.leaveInfo.leave_code);
          setNomprenom(res.nomprenom);
          setLeaveID(id);
          setuserSupList(res.userSupList);
          setLoadingSendForValidation(false);
          setQrCode(res.qrCode);
          setIsValidPlanning(res.isValidPlanning);
        }

        if (!isRealBalanceAlreadyConfigurate) {
          LeaveService.getBalanceBefore().then((result) => {
            setBalanceBefore(result.data);
          });
          LeaveService.getRealBalanceBefore().then((result) => {
            setRealdelta(result.data);
          });
          LeaveService.getBalanceAfter(res.duration).then((result) => {
            setBalanceAfters(result.data);
          });
          LeaveService.getRealBalanceAfter(res.duration).then((result) => {
            setAfterdelta(result.data);
          });
        } else {
          LeaveService.getBalanceBefore().then((result) => {
            setBalanceBefore(result.data);
            const totalProvisionalBalance = result.data - res.duration;
            setBalanceAfters(totalProvisionalBalance);
          });
          LeaveService.getRealBalanceBefore().then((result) => {
            setRealdelta(result.data);
            const totalRealBalance = (res.type == "congé") ? (result.data - res.duration) : result.data;
            setAfterdelta(totalRealBalance);
          });
        }
      })
      .catch((err) => {
        setLoadingSendForValidation(false);
        setOpenLoadingSimpleBackdrop(false);
      });
  }, [isRealBalanceAlreadyConfigurate]);

  const handleCancelLeave = useCallback(() => {
    FileService.deleteFile(filename)
      .then((res) => {
        if (res.status) {
          setOpen(false);
        }
      })
      .catch((err) => {});
  }, [filename]);

  const handleValidateLeave = useCallback(() => {
    setLoadingHandleValidateLeave(true);
    LeaveService.validateFile(leaveID, filename, leavecode, qrCode, isValidatorNumberConfigurate, dayOffNumberWithoutValidation)
      .then((res) => {
        if (res.status) {
          setOpen(false);
          LoadTable();
          loadPendingRealLeaveDurations();
          setLoadingHandleValidateLeave(false);
        }
      })
      .catch((err) => {
        setLoadingHandleValidateLeave(false);
      });
  }, [leaveID, filename, leavecode, qrCode, isValidatorNumberConfigurate, dayOffNumberWithoutValidation, LoadTable, loadPendingRealLeaveDurations]);

  const handleCancelingLeave = useCallback(() => {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false, messageDialog: "Voulez-vous vraiment annuler la demande de congé" });
    setCancel(true);
  }, [confirmationDialog]);

  const handlecancel = useCallback((id, code, idleave, is, status) => (ev) => {
    if (status == "Planning confirmé" || status == "Planning en attente" ||
      status == "Planning validé" || status == "Planning réel confirmé") {
      setIsPlanning(true);
      setConfirmationDialog({ ...confirmationDialog, openDialog: true, messageDialog: "Voulez-vous vraiment annuler cette planification de congé" });
    } else {
      setConfirmationDialog({ ...confirmationDialog, openDialog: true, messageDialog: "Voulez-vous vraiment annuler la demande de congé" });
    }
    setIdleave(idleave);
    setIdobselete(id);
    setCodeobselete(code);
    setLeave(is);
    setIscancel(true);
    setIdLeaveToCancel(id);
  }, [confirmationDialog]);

  const handleRaison = useCallback((ev) => {
    setRaison(ev.target.value);
    setEmptyMotif(false);
  }, []);

  const handleValidCancel = useCallback(() => {
    setLoading(true);
    setEmptyMotif(false);
    if (raison && raison.trim().length !== 0 && raison !== undefined) {
      LeaveService.getLeaveObselete(raison, codeobselete, leaveid, leave, isPlanning).then((result) => {
        LeaveService.getLeaveType().then((results) => {
          if (results && results.data) {
            setLoading(false);
            setData(results.data);
            LoadTable();
          }
        });
        if (result != "") {
          if (result.status) {
            setCancel(false);
            setRaison("");
            loadPendingRealLeaveDurations();
            setMessage({ ...message, openMessage: true, color: 'green', messageInfo: result.data.message });
            setEmptyMotif(false);
          } else {
            setMessage({ ...message, openMessage: true, color: 'red', messageInfo: result.message });
          }
        } else {
          setMessage({ ...message, openMessage: true, color: 'red', messageInfo: "Une erreur s'est produite. Veuillez réessayer" });
        }
      }).catch((err) => {
        setMessage({ ...message, openMessage: true, color: 'red', messageInfo: 'erreur' });
      });
    } else {
      setEmptyMotif(true);
      setLoading(false);
    }
  }, [raison, codeobselete, leaveid, leave, isPlanning, message, LoadTable, loadPendingRealLeaveDurations]);

  const handleCloseCancel = useCallback((event, reason) => {
    if (reason === "backdropClick") {
      return false;
    }
    setCancel(false);
  }, []);

  const handleClickPdf = useCallback(() => {
    FileService.readFile(filename).then((result) => {
      if (result) {
        const blob = new Blob([result.data], {
          type: 'application/pdf',
        });
        const fileURL = URL.createObjectURL(blob);
        const w = window.open(fileURL, '_blank');
        w && w.focus();
        URL.revokeObjectURL(fileURL);
      }
    });
  }, [filename]);

  const handleModifLeavePlanning = useCallback(() => {
    navigate(`/me/leaves/add/editPlanning/${leaveID}`);
  }, [navigate, leaveID]);

  const columns = [
    {
      field: 'fullName',
      headerName: 'Nom et prénom(s)',
      width: 350,
      valueGetter: getFullName,
      sortComparator: (v1, v2, cellParams1, cellParams2) =>
        getFullName(cellParams1).localeCompare(getFullName(cellParams2)),
    },
    {
      field: 'leave_code',
      headerName: 'Identification',
      width: 300,
      cellClassName: 'identifiant',
    },
    {
      field: "begin_time",
      headerName: "Date de départ",
      width: 200,
      valueFormatter: (params) => {
        return `${moment(params.row.begin_time).format('DD/MM/YYYY')} ${params.row.begin_time_session === 'morning' ? 'Matin' : 'Après-midi'}`;
      },
    },
    {
      field: "end_time",
      headerName: "Date de retour",
      width: 200,
      valueFormatter: (params) => {
        return `${moment(params.row.end_time).format('DD/MM/YYYY')} ${params.row.end_time_session === 'morning' ? 'Matin' : 'Après-midi'}`;
      },
    },
    {
      field: "leave_type_id",
      headerName: "Type",
      width: 200,
      valueFormatter: (params) => {
        const leaveType = leaveTypes.find(
          (type) => type.id === params.row.leave_type_id
        );
        return leaveType ? `${leaveType.label} - ${leaveType.desc}` : undefined;
      },
    },
    { field: "reason", headerName: "Motif", width: 200 },
    { field: "duration", headerName: "Durée (en jours)", width: 200 },
    {
      field: "states",
      headerName: "Statut",
      width: 300,
      valueFormatter: (params) => {
        return `${((params.row.StateValidate === 'DECLINED' && params.row.StatusPlanning === 'CONFIRMED' && selectedStatus == 1) ||
          (params.row.statusFinal === "Congé consommé" && params.row.states === "2/2")) || params.row.statusFinal === "Annulé" ? params.row.statusFinal :
          (params.row.StateValidate === 'Validé' && params.row.StatusPlanning === 'CONFIRMED' && selectedStatus == 1) ? "Planning réel validé" :
            (params.row.states !== null && params.row.StatusPlanning !== null && selectedStatus == 1) ? "Réel " + params.row.states :
              (params.row.states !== null && params.row.StatusPlanning !== null && selectedStatus == 2) ? "Planning validé " :
                params.row.statusFinal === "Congé validé" ? "Réel " + params.row.states : params.row.statusFinal === "En attente" ? "Réel " + params.row.states :
                  params.row.statusFinal === "Nouveau" ? "Nouveau" : params.row.statusFinal === "Confirmé" ? "Réel " + params.row.states :
                    params.row.statusFinal === "Planning confirmé" ? "Planning " + params.row.statePlanning :
                      params.row.statusFinal === params.row.statusFinal.split("Planning refusé") ? params.row.statusFinal :
                        params.row.statusFinal.split("Refusé par") ? params.row.statusFinal : params.row.statusFinal === "Planning en attente" ? "Planning en attente" :
                          params.row.statusFinal === "Congé consommé" ? params.row.statusFinal : "Planning validé"}`;
      },
    },
    {
      field: "observation",
      headerName: "Observation",
      width: 200,
      valueFormatter: (params) => {
        return params.row.observation && params.row.observation !== undefined && params.row.observation.trim() !== "" ?
          params.row.observation : "-";
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => (
        <span>
          {params.row.statusFinal === "Nouveau" && (
            <>
              <Button
                onClick={handleGenerateFile(params.id)}
                title="Envoyer pour validation"
                disabled={isLoadingSendForValidation ? true : false}
              >
                <CheckIcon style={{ color: "green" }} />
              </Button>
              <Button onClick={handleEdit(params.id)} title="Modifier">
                <CreateTwoTone style={{ color: "black" }} />
              </Button>
              <Button onClick={handleDelete(params.id)} title="Supprimer">
                <DeleteOutlineRounded style={{ color: "red" }} />
              </Button>
            </>
          )}
          {(params.row.statusFinal === "Planning validé" && (params.row.states === "" || params.row.states === null)) && (
            <>
              <Button
                onClick={handleGenerateFile(params.id)}
                title="Envoyer pour validation"
              >
                <CheckIcon style={{ color: "green" }} />
              </Button>
            </>
          )}
          {params.row.statusReel === "DECLINED" && selectedStatus == 1 && (
            <Button title="Refusé">
              <RemoveIcon style={{ color: "rgb(19, 62, 103)" }} />
            </Button>
          )}
          {params.row.statusFinal === "En attente" && (
            <Button onClick={handlecancel(params.id, params.row.leave_code, params.row.file_request_id, params.row.leave_id, params.row.statusFinal)} title="Annuler ">
              <CloseIcon style={{ color: "red" }} />
            </Button>
          )}
          {params.row.statusFinal === "Confirmé" && (
            <Button onClick={handlecancel(params.id, params.row.leave_code, params.row.file_request_id, params.row.leave_id, params.row.statusFinal)} title="Annuler ">
              <CloseIcon style={{ color: "red" }} />
            </Button>
          )}
          {params.row.statusFinal === "Planning confirmé" && (
            <Button onClick={handlecancel(params.id, params.row.leave_code, params.row.file_request_id, params.row.leave_id, params.row.statusFinal)} title="Annuler ">
              <CloseIcon style={{ color: "red" }} />
            </Button>
          )}
          {params.row.statusFinal === "Planning en attente" && (
            <Button onClick={handlecancel(params.id, params.row.leave_code, params.row.file_request_id, params.row.leave_id, params.row.statusFinal)} title="En attente ">
              <CloseIcon style={{ color: "red" }} />
            </Button>
          )}
          {params.row.statusFinal === "Congé validé" && (
            <>
              <Button onClick={handleValide(params.id)} title="Confirmer">
                <DoneAllIcon style={{ color: "rgb(19, 62, 103)" }} />
              </Button>
            </>
          )}
          {params.row.StatusPlanning === "DECLINED" && (
            <Button onClick={handleEdit(params.id)} title="Modifier">
              <CreateTwoTone style={{ color: "black" }} />
            </Button>
          )}
          {((params.row.statusFinal === "Planning réel validé" && selectedStatus == 1) || (params.row.statusFinal === "Planning réel validé" && params.row.states === "2/2")) && (
            <>
              <Button onClick={handleValide(params.id)} title="Valider">
                <DoneAllIcon style={{ color: "rgb(19, 62, 103)" }} />
              </Button>
            </>
          )}
          {((params.row.statusFinal === "Planning validé" && params.row.states === "0/2") || (params.row.statusFinal === "Planning réel confirmé" && params.row.states !== null)) && (
            <Button onClick={handlecancel(params.id, params.row.leave_code, params.row.file_request_id, params.row.leave_id, params.row.statusFinal)} title="Annuler ">
              <CloseIcon style={{ color: "red" }} />
            </Button>
          )}
        </span>
      ),
    },
  ];

  return (
    <>
      {iscancel === false && <ConfirmationDialog openDialog={openDialog} messageDialog={messageDialog} closeDialog={closeDialog} confirmDialog={confirmDialog} cancelDialog={cancelDialog} isCancel={iscancel}
        isPlanning={isPlanning} />}
      {iscancel === true && <ConfirmationDialog openDialog={openDialog} messageDialog={messageDialog} closeDialog={closeDialog} confirmDialog={handleCancelingLeave} cancelDialog={cancelDialog}
        isCancel={iscancel} idLeave={idLeaveToCancel} isPlanning={isPlanning} />}
      <Message open={openMessage} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      
      <Grid container item xs={12} spacing={2}>
        <Grid item xs={3}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel id="status-select-label">Statut</InputLabel>
            <Select
              labelId="status-select-label"
              id="status-select"
              value={selectedStatus}
              label="Statut"
              onChange={handleChangeStatus}
            >
              <MenuItem value={0}>Nouveau</MenuItem>
              <MenuItem value={1}>Réel</MenuItem>
              <MenuItem value={2}>Planning</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={7}>
          <div className={classes.balanceSummaryContent}>
            <div className={classes.balanceSummary}>
              <div className={`${classes.balanceLine} ${classes.currentBalanceLine}`}>
                <b>{userConnectedName}</b> — Votre solde actuel (<b>sans validation/confirmation</b>) est de{" "}
                <span className={classes.currentBalance}>{currentBalance} jour(s)</span>
              </div>
              <div className={classes.balanceLine}>
                votre Solde réel <b>après validation/confirmation</b> est de :{" "}
                {isPendingBalanceAvailable ? (
                  <span className={classes.confirmedBalance}>
                    {balanceAfterValidationAndConfirmation} jour(s)
                  </span>
                ) : (
                  <span className={classes.balanceUnavailable}>indisponible</span>
                )}
              </div>
            </div>
            <Button
              aria-label="Afficher le détail du solde"
              aria-describedby={isBalanceDetailsOpen ? "balance-details-popover" : undefined}
              title="Afficher le détail du solde"
              size="small"
              variant="outlined"
              startIcon={<InfoOutlinedIcon />}
              className={classes.balanceDetailsButton}
              onClick={handleOpenBalanceDetails}
            >
              Détails
            </Button>
          </div>
          <Popover
            id="balance-details-popover"
            open={isBalanceDetailsOpen}
            anchorEl={balanceDetailsAnchorEl}
            onClose={handleCloseBalanceDetails}
            anchorOrigin={{ vertical: "center", horizontal: "right" }}
            transformOrigin={{ vertical: "center", horizontal: "left" }}
            PaperProps={{ className: classes.balanceDetailsPaper }}
          >
            <div className={classes.balanceDetails}>
              <div className={classes.balanceDetailsTitle}>Détail du solde</div>
              <div className={classes.balanceDetailsRow}>
                <span>Solde actuel</span>
                <span className={classes.balanceDetailsValue}>{currentBalance} jour(s)</span>
              </div>
              <div className={classes.balanceDetailsRow}>
                <span>Congé en attente de validation</span>
                {isPendingBalanceAvailable ? (
                  <span className={classes.balanceDetailsValue}>{pendingValidation} jour(s)</span>
                ) : (
                  <span className={classes.balanceUnavailable}>indisponible</span>
                )}
              </div>
              <div className={classes.balanceDetailsRow}>
                <span>Congé en attente de confirmation</span>
                {isPendingBalanceAvailable ? (
                  <span className={classes.balanceDetailsValue}>{pendingConfirmation} jour(s)</span>
                ) : (
                  <span className={classes.balanceUnavailable}>indisponible</span>
                )}
              </div>
              <div className={classes.balanceDetailsRow}>
                <span>Solde réel après validation/confirmation</span>
                {isPendingBalanceAvailable ? (
                  <span className={classes.balanceDetailsValue}>
                    {balanceAfterValidationAndConfirmation} jour(s)
                  </span>
                ) : (
                  <span className={classes.balanceUnavailable}>indisponible</span>
                )}
              </div>
              <div className={classes.balanceDetailsActions}>
                <Button
                  variant="contained"
                  className={classes.balanceDetailsCloseButton}
                  onClick={handleCloseBalanceDetails}
                >
                  Fermer
                </Button>
              </div>
            </div>
          </Popover>
        </Grid>
      </Grid>

      
      <Title>Absence / Congé</Title>

      <div style={{ height: "70vh", width: "100%" }}>
        <DataGrid
          columns={columns}
          rows={filteredRows}
          pageSize={7}
          rowsPerPageOptions={[7]}
          disableSelectionOnClick
          getRowClassName={(params) =>
            (params.row.statusReel === "DECLINED" || params.row.StatusPlanning === "DECLINED") ? 'declinedRow' : ''
          }
        />
      </div>

      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="form-dialog-title">Detail de votre {type} </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <label className={classes.id}>Identification:</label>
            </Grid>
            <Grid item xs={8}>
              <label className={classes.id}>{leavecode}</label>
            </Grid>

            <Grid item xs={4}>
              <label className={classes.label}>Nom et Prénom du demandeur:</label>
            </Grid>
            <Grid item xs={8}>
              <label className={classes.label1}>{nomprenom}</label>
            </Grid>

            <Grid item xs={4}>
              <label className={classes.label}>Date de Départ:</label>
            </Grid>
            <Grid item xs={2}>
              <label className={classes.label1}>{beginMoment}</label>
            </Grid>
            <Grid item xs={6}>
              <label className={classes.label1}>{beginMomentSession}</label>
            </Grid>

            <Grid item xs={4}>
              <label className={classes.label}>Date de retour:</label>
            </Grid>
            <Grid item xs={2}>
              <label className={classes.label1}>{endMoment}</label>
            </Grid>
            <Grid item xs={6}>
              <label className={classes.label1}>{endMomentSession}</label>
            </Grid>

            <Grid item xs={4}>
              <label className={classes.label}>Nombre de jours:</label>
            </Grid>
            <Grid item xs={8}>
              <label className={classes.label1}>{duration}</label>
            </Grid>
            <Grid item xs={4}>
              <label className={classes.label}>Motif:</label>
            </Grid>
            <Grid item xs={8}>
              <label className={classes.label1}>{reason}</label>
            </Grid>

            <Grid item xs={4}>
              <label className={classes.label}>Solde réelle avant:</label>
            </Grid>
            <Grid item xs={8}>
              <label className={classes.label1}>{realdelta}</label>
            </Grid>
            <Grid item xs={4}>
              <label className={classes.label}>Solde réelle après:</label>
            </Grid>
            <Grid item xs={8}>
             <label className={classes.label1}>{realdelta - duration}</label>
            </Grid>
          </Grid>
          <br></br>
          <span>
            Le rendu de votre demande sous forme{" "}
            <Link
              to={"#"}
              onClick={handleClickPdf}
            >
              pdf.
            </Link>
            <br></br>
            {!isValidPlanning &&
              <>
                {isValidatorNumberConfigurate && duration <= dayOffNumberWithoutValidation &&
                  <Alert severity="info">
                    <span>
                    Dans le cadre d'une configuration spéciale sans validation associée à votre compte,
                    vous avez la possibilité de le valider directement, ce qui déclenchera l'envoi automatique d'une notification aux équipes des ressources humaines</span>
                  </Alert>
                }

                {isValidatorNumberConfigurate && duration > dayOffNumberWithoutValidation &&
                  <span>
                   Dans le cadre d'une configuration spéciale sans validation associée à votre compte,
                   cette demande de congé sera envoyé pour validation de votre supérieur hierarchique : <label className={classes.label1}>
                      <span><b>{userSupList.last_name + ' ' + userSupList.first_name}</b></span></label>
                    <br></br>
                    Confirmez-vous votre action?
                  </span>
                }
                {!isValidatorNumberConfigurate &&
                  <>
                    <span>"Cette demande de congé sera envoyé pour validation de votre supérieur hierarchique : <label className={classes.label1}>
                      <span><b>{userSupList.last_name + ' ' + userSupList.first_name}</b></span>
                    </label>"</span>
                    <br></br>
                    Confirmez-vous votre action?
                  </>
                }
              </>
            }
            {isValidPlanning &&
              <>
                <Alert severity="info">
                  <span>Ceci est un planning validé!<br /> Vous pouvez le modifier en cliquant sur le bouton "<i>Modifier</i>" ou l'envoyer à votre supérieur hiérarchique
                pour demander sa validation à l'aide du bouton "<i>Valider</i>".<br />
                    <b><u>NB:</u></b>Votre supérieur hiérarchique actuel est <b>{userSupList.last_name + ' ' + userSupList.first_name}</b>
                  </span>
                </Alert>
              </>
            }
          </span>
        </DialogContent>
        <DialogActions>
          {!isValidPlanning &&
            <>
              <Button
                style={{ backgroundColor: "##f50057", color: "#FFFFFF" }}
                onClick={handleCancelLeave}
                color="secondary"
                variant="contained"
              >
                Annuler
              </Button>
            {/* Commenter la validation car le calcul de solde réel aprés est erronnée */}
            {/*   {parseInt(afterdelta) > 0 && */}
                <Button
                  style={{ backgroundColor: "rgb(19, 62, 103)", color: "#FFFFFF" }}
                  onClick={handleValidateLeave}
                  color="primary"
                  variant="contained"
                  disabled={isLoadingHandleValidateLeave ? true : false}
                >
                   {isLoadingHandleValidateLeave ? <CircularProgress /> : "Envoyer pour validation"}
                </Button>
             {/* } */}
            </>
          }
          {isValidPlanning &&
            <>
              <Button
                style={{ backgroundColor: "##f50057", color: "#FFFFFF" }}
                onClick={handleCancelLeave}
                color="secondary"
                variant="contained"
              >
                Retour
              </Button>
              <Button
                style={{ backgroundColor: "rgb(106, 207, 246)", color: "#FFFFFF" }}
                onClick={handleModifLeavePlanning}
                color="primary"
                variant="contained"
                disabled={isLoadingHandleValidateLeave ? true : false}
              >
                {isLoadingHandleValidateLeave ? <CircularProgress /> : "Modifier"}
              </Button>
              <Button
                style={{ backgroundColor: "rgb(19, 62, 103)", color: "#FFFFFF" }}
                onClick={handleValidateLeave}
                color="primary"
                variant="contained"
                disabled={isLoadingHandleValidateLeave ? true : false}
              >
                {isLoadingHandleValidateLeave ? <CircularProgress /> : "Valider"}
              </Button>
            </>
          }
        </DialogActions>
      </Dialog>
      
      <MotifAnnulationLeave 
        openDialog={cancel} 
        handleCloseCancel={handleCloseCancel} 
        raison={raison}
        handleRaison={handleRaison} 
        emptyMotif={emptyMotif} 
        isLoading={isLoading} 
        handleValidCancel={handleValidCancel}
        isPlanning={isPlanning} 
      />
    </>
  );
}